import {
  ArrowDownLeft,
  ArrowsClockwise,
  ArrowUpRight,
  CaretDown,
  CaretRight,
  ChartBar,
  Check,
  ClockCountdown,
  Copy,
  CurrencyDollar,
  Eye,
  EyeSlash,
  Gear,
  Gift,
  Globe,
  HardDrive,
  HardDrives,
  House,
  Info,
  Key,
  Lifebuoy,
  Lightning,
  MagnifyingGlass,
  MapPin,
  Megaphone,
  Memory,
  Minus,
  Moon,
  type Icon as PhosphorIcon,
  Plus,
  PencilSimple,
  Power,
  Prohibit,
  Receipt,
  RocketLaunch,
  Shield,
  SignOut,
  Sparkle,
  Sun,
  Terminal,
  Translate,
  Trash,
  UserCircle,
  Users,
  Wallet,
  WarningCircle,
  X,
} from '@phosphor-icons/react';

/**
 * One icon family (Phosphor) for the whole app, so strokes, corners and optical size match.
 * Names describe the meaning, not the drawing, so screens don't care which glyph is behind them.
 */
const ICONS = {
  chevron: CaretRight,
  chevronDown: CaretDown,
  copy: Copy,
  check: Check,
  close: X,
  home: House,
  globe: Globe,
  server: HardDrives,
  disk: HardDrive,
  cpu: Lightning,
  memory: Memory,
  wallet: Wallet,
  user: UserCircle,
  plus: Plus,
  edit: PencilSimple,
  search: MagnifyingGlass,
  clock: ClockCountdown,
  alert: WarningCircle,
  info: Info,
  power: Power,
  reboot: ArrowsClockwise,
  trash: Trash,
  key: Key,
  terminal: Terminal,
  shield: Shield,
  pin: MapPin,
  settings: Gear,
  language: Translate,
  currency: CurrencyDollar,
  moon: Moon,
  sun: Sun,
  support: Lifebuoy,
  eye: Eye,
  eyeOff: EyeSlash,
  arrowDown: ArrowDownLeft,
  arrowUp: ArrowUpRight,
  chart: ChartBar,
  gift: Gift,
  rocket: RocketLaunch,
  blocked: Prohibit,
  bolt: Lightning,
  users: Users,
  receipt: Receipt,
  megaphone: Megaphone,
  minus: Minus,
  ai: Sparkle,
  signOut: SignOut,
} satisfies Record<string, PhosphorIcon>;

export type IconName = keyof typeof ICONS;
export type IconWeight = 'regular' | 'bold' | 'fill' | 'duotone';

export function Icon({
  name,
  size = 20,
  label,
  className,
  weight = 'regular',
}: {
  name: IconName;
  size?: number;
  /** Accessible name; without it the icon is decorative and hidden from screen readers. */
  label?: string;
  className?: string;
  weight?: IconWeight;
}) {
  const Glyph = ICONS[name];
  return (
    <Glyph
      className={['ul-icon', className].filter(Boolean).join(' ')}
      size={size}
      weight={weight}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
      focusable="false"
    />
  );
}
